<template>
  <Block type="reverse">
    <Container>
      <div class="infographic">
        <div class="infographic__item">
          {{ orgConfig("datasets.count") }}
          <small>{{ $t("datasets_count") }}</small>
        </div>
        <div class="infographic__item">
          {{ orgConfig("api.keys") }}
          <small>{{ $t("implementation_count") }}</small>
        </div>
        <div class="infographic__item">
          {{ orgConfig("api.requests") }}
          <small>{{ $t("calls_count") }}</small>
        </div>
      </div>
    </Container>
  </Block>
</template>

<script>
import Block from "@/components/homepage/Block";
import Container from "@/components/homepage/Container";
import { orgConfig } from "@/mixins";

export default {
  mixins: [orgConfig],
  components: {
    Block,
    Container
  }
};
</script>

<style lang="scss" scoped></style>
